import { Container } from '@mui/material';
import { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { PageLayout } from 'src/layouts/page-layout';
import { NewsBlock } from './news-block';

export const News: ComponentType = () => {
  const { t } = useTranslation();
  return (
    <PageLayout
      title={t('portalNews', 'Новости портала')}
      subtitle={t(
        'portalNews.subtitle',
        'Актуальные новости, информация о ближайших аттестациях и другие события'
      )}
    >
      <Container>
        <NewsBlock showItems={9} pb={9} loadMoreBtn />
      </Container>
    </PageLayout>
  );
};
